module.exports = "::ng-deep .mat-chip-list-wrapper .mat-chip{flex:0 0 auto}\n"